import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getMilesConversionRate } from '@services/milesConversion.service';
import { IMilesConversion } from '@interfaces/milesConversion';

export const fetchMilesConversionRate = createAsyncThunk('biz/fetchMilesConversionRate', async (currencyCode: string) => {
	return await getMilesConversionRate(currencyCode);
});

export interface MilesConversionState {
	milesConversion: IMilesConversion;
	isLoading: boolean;
}

const initialState = {
	milesConversion: {
		_id: '',
		currencyCode: '',
		valueOfOneMile: 0,
		isActive: true,
	},
	isLoading: true,
} satisfies MilesConversionState as MilesConversionState;

const milesConversionSlice = createSlice({
	name: 'milesConversion',
	initialState: initialState,
	reducers: {
		fetchMilesConversion: (state, action: PayloadAction<MilesConversionState>) => {
			return {
				...state.milesConversion,
				...action.payload,
			};
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchMilesConversionRate.pending, (state: MilesConversionState) => {
			state.isLoading = true;
		});
		builder.addCase(fetchMilesConversionRate.fulfilled, (state: MilesConversionState, action) => {
			state.isLoading = false;
			state.milesConversion = action.payload['data'] ?? [];
		});
		builder.addCase(fetchMilesConversionRate.rejected, (state: MilesConversionState) => {
			state.isLoading = false;
		});
	},
});

export const milesConversionReducer = milesConversionSlice.reducer;
export default milesConversionSlice;
